const comments = [
  {
    name: '电影爱好者小陈',
    text: '51影院真的太方便了！奇优影院和98影院的资源都能在这里找到，不用来回切换站点，片源更新速度也很快，推荐给身边所有爱看电影的朋友。',
    time: '2小时前',
    likes: 328,
  },
  {
    name: '追剧达人阿琳',
    text: '优优色影院和cc影院的内容在这里都能看到，画质清晰流畅，关键是每日更新很及时，新剧出来当天就能看，比追其他平台快多了。',
    time: '5小时前',
    likes: 256,
  },
  {
    name: '影评人老王',
    text: '96影院的老片修复版居然在这里全集上线了，画质修复得相当不错。51影院整合多站资源确实是个好思路，影迷福音。',
    time: '8小时前',
    likes: 189,
  },
  {
    name: '学生党小明',
    text: '作为大学生预算有限，51影院免费高清在线看对我太友好了。动漫、电影、综艺种类齐全，宿舍日常就靠这个打发时间了。',
    time: '12小时前',
    likes: 412,
  },
  {
    name: '家庭观影李姐',
    text: '家里老人小孩都能找到合适的节目，操作界面简单，播放流畅不卡顿。51影院真的是全家人的观影首选，每天都有新惊喜。',
    time: '1天前',
    likes: 175,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">观众热评</h2>
          <p className="text-sm text-foreground-500">真实用户反馈，听听大家怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((c, i) => (
            <div
              key={i}
              className="p-5 rounded-lg bg-background-50 border border-background-200/40"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                  <span className="font-heading text-sm text-primary-400">{c.name[0]}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-200">{c.name}</p>
                  <p className="text-xs text-foreground-600">{c.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-3">
                &ldquo;{c.text}&rdquo;
              </p>
              <div className="flex items-center gap-2 text-foreground-600 text-xs">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}